import styled from 'styled-components';

export const FormGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const RequiredFieldNote = styled.span`
  color: ${({ theme }) => theme.colors.red5};
  margin-right: 4px;
`;
export const FormRow = styled.div<{ columns?: number }>`
  display: grid;
  grid-template-columns: repeat(${props => props.columns || 1}, 1fr);
  gap: 16px;

  @media (max-width: ${({ theme }) => theme.mediaQueries.md}) {
    grid-template-columns: 1fr;
  }
`;

export const FormFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
`;

export const FieldLabel = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const DocumentInputWrapper = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;

  .type-selector {
    min-width: 140px;

    .ant-form-item {
      margin-bottom: 0;
    }
  }

  .number-input {
    flex: 1;

    .ant-form-item {
      margin-bottom: 0;
    }
  }
`;
